<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="news-card" @click="() => showDetails(card)">
    <div class="news-card-inner">
      <div class="info-wrap">
        <div class="news-card-title">{{ card.title }}</div>
        <div class="news-cards-desc">{{ textDescShowed }}</div>
        <div v-if="!isMobile" class="extra-wrap">
          <div class="extra-calendar">
            <div class="icon-calendar" />
            <div class="date-news">{{ card.date }}</div>
          </div>
          <div v-if="parsedCategories.length" class="tags-wrapper">
            <div v-for="(thesau, j) in parsedCategories" :key="j" class="tag">
              <span
                v-for="(saurus, i) in thesau"
                :key="saurus"
                :class="i === thesau.length - 1 ? ' bold' : ''"
              >
                {{ saurus.replace('~', ',') + (i !== thesau.length - 1 ? ' > ' : '') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="card.photo" class="img-wrap">
        <div class="newscard-img" :style="'background-image: url(' + photoBlob + ')'" />
      </div>
    </div>
    <div v-if="isMobile" class="extra-wrap">
      <div class="extra-calendar">
        <div class="icon-calendar" />
        <span class="date-news">{{ card.date }}</span>
      </div>
      <div v-if="parsedCategories.length" class="tags-wrapper">
        <div v-for="(thesau, j) in parsedCategories" :key="j" class="tag">
          <span
            v-for="(saurus, i) in thesau"
            :key="saurus"
            :class="i === thesau.length - 1 ? ' bold' : ''"
          >
            {{ saurus.replace('~', ',') + (i !== thesau.length - 1 ? ' > ' : '') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { vCmsHtml as cms, getCmsResourceBlob } from '@/services/graphql'
export default {
  components: {},
  directives: { cms },
  props: {
    card: {
      type: Object,
    },
  },
  data() {
    return {
      photoBlob: '',
    }
  },
  computed: {
    parsedCategories() {
      return this.card.category.map(el => el.split(','))
    },
    textDescShowed() {
      let finalString = ''
      let regex = /(<([^>]+)>)/gi
      let parsedString = this.card.desc.replace(regex, '')
      finalString = parsedString.length <= 200 ? parsedString : parsedString.slice(0, 197) + '...'
      return finalString
    },
  },
  watch: {
    'card.photo': {
      immediate: true,
      handler(val) {
        if (val) {
          getCmsResourceBlob(val)
            .then(blob => {
              this.photoBlob = URL.createObjectURL(blob)
            })
            .catch(ex => {
              console.log(ex)
            })
        }
      },
    },
  },
  methods: {
    showDetails(card) {
      this.$emit('toggle-selected-card', card)
      this.$modal.show('modal-news-card')
    },
  },
}
</script>

<style lang="stylus" scoped>
.news-card
  background-color: #fff
  border: 1px solid #fff
  border-radius: 8px
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
  cursor: pointer
  padding: vw(20px) vw(30px)

  .mobile &
    padding: vw(20px)

  &:hover
    border-color: $corporate_color

.news-card-inner
  display: flex
  gap: vw(50px)

  .mobile &
    flex-direction: column-reverse
    gap: vw(10px)

  .info-wrap
    display: flex
    flex: 1 1 0%
    flex-direction: column

  .img-wrap
    flex: 0 0 vw(170px)

    .mobile &
      margin-bottom: vw(10px)

    .newscard-img
      m-keep-ratio("4-3")
      background-position: center center
      background-repeat: no-repeat
      background-repeat: no-repeat
      background-size: cover

.news-card-title
  m-font-size(24, 30)
  font-weight: 600
  margin-bottom: vw(5px)

.news-cards-desc
  m-font-size(14, 22)
  color: $grey
  font-weight: 300
  margin-bottom: vw(20px)

.extra-wrap
  align-items: flex-start
  display: flex

  .tags-wrapper
    display: flex
    flex-wrap: wrap
    gap: vw(5px)
    margin-top: vw(-4px)

  .tag
    m-font-size(12, 16)
    border: 1px solid $corporate_color_light
    border-radius: 20px
    color: $grey-dark
    font-weight: 400
    padding: vw(4px) vw(12px)

    .bold
      color: black
      font-weight: 600

  .extra-calendar
    align-items: center
    display: flex

    &:not(:only-child)
      border-right: 1px solid $bcn-other-grey
      margin-right: vw(10px)
      padding-right: vw(10px)

    .icon-calendar
      m-icon("calendar", 16)
      margin-right: vw(6px)

    .date-news
      m-font-size(12, 16)
      color: $grey-dark
      font-weight: 400
      text-transform: capitalize
      white-space: nowrap
</style>